module.exports = __webpack_public_path__ + "img/camera-plus 1.08091407.svg";